// @flow

import React from "react";
import { localize } from "redux-i18n";
import type { FormProps } from "redux-form";

import { View, Text, Checkbox } from "@components";

type OwnProps = $Exact<{
  data: ?Object,
  schema: Object,
  editing?: boolean,
  onChange?: (data: Object) => void,
  onSubmit?: (data: Object) => void,
}>;

type Props = $Exact<{
  ...OwnProps,
  ...PropsFromLocalize,
  ...$Exact<FormProps>, // https://stackoverflow.com/a/44771268/220839
}>;

export class EmailNotificationContent extends React.Component<Props> {
  get fields(): Array<string> {
    return [
      "includeEmployeePhoneNumber",
      "includeWorkingHours",
      "includeBradfordScore",
      "includeJobTitle",
      "includeAbsenceId",
      "includeLastThreeAbsences",
      "includeDepartmentParent",
      "includeEmployeeRef",
      "includePosition",
      "includeAbsenceReason",
    ];
  }

  handleChange = (value: any, id: string) => {
    if (this.props.onChange) {
      this.props.onChange({
        ...this.props.data,
        [id]: !this.props.data[id],
      });
    }
  };

  render() {
    return (
      <View>
        <Text lineHeight="3rem" type="h5">
          {this.props.t("FIELDS")}
        </Text>
        <View key="id" display="grid" gap={1} gridTemplateColumns={3} padding="1rem 0">
          {this.fields &&
            this.fields.map(k => {
              const id = this.props.editing ? k : `_${k}`;
              return (
                <Checkbox
                  key={id}
                  id={id}
                  label={((this.props.schema || {}).properties[k] || {}).title}
                  checked={(this.props.data || {})[k]}
                  onChange={value => this.handleChange(value, id)}
                  disabled={!this.props.editing}
                />
              );
            })}
        </View>
      </View>
    );
  }
}

export default localize()(EmailNotificationContent);
